import { useState, useEffect } from "react";

const el = document.getElementById("dealers-map-root");
const locale = el?.getAttribute("data-locale");
const el2 = document.getElementById("models-comparator-root");
const locale2 = el2?.getAttribute("data-locale");
// const root = ReactDOM.createRoot(el);
// const contact = root._internalRoot.containerInfo.dataset.contact;

export default function useGetTranslations(url) {
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        async function fetchTranslations() {
            const response = await fetch(url, {
                headers: {
                    "Accept-Language": locale || locale2,
                },
            });
            const data = await response.json();
            setTranslations(data);
        }
        fetchTranslations();
    }, []);

    return [translations, setTranslations];
}
